export default function ContactMap() {
  return (
    <div className="w-full flex flex-col">
      {/* Map Header */}
      <div className="flex items-center gap-3 mb-4">
        <div className="w-1 h-6 bg-[#1a73b5]" />
        <h3 className="text-base font-bold text-gray-800">公司位置</h3>
      </div>

      {/* Google Map Embed */}
      <div className="w-full h-[300px] md:h-[360px] border border-gray-100 overflow-hidden">
        <iframe
          title="益維企業有限公司位置"
          src="https://maps.google.com/maps?q=%E5%8F%B0%E5%8C%97%E5%B8%82%E5%8D%97%E6%B8%AF%E5%8D%80%E5%8D%97%E6%B8%AF%E8%B7%AF%E4%B8%89%E6%AE%B599%E8%99%9F9%E6%A8%93&t=&z=16&ie=UTF8&iwloc=&output=embed"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>

      {/* Address Detail */}
      <div className="mt-4 flex flex-col gap-2.5">
        <div className="flex items-start gap-3">
          <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-map-pin-2-line text-[#1a73b5] text-base" />
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-800">台北市南港區南港路三段99號9樓</p>
            <p className="text-xs text-gray-500">9F, No.99, Sec.3, Nankang Rd., Taipei, Taiwan, R.O.C.</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
            <i className="ri-bus-line text-[#1a73b5] text-base" />
          </div>
          <p className="text-sm text-gray-600">捷運南港展覽館站步行約 10 分鐘</p>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
            <i className="ri-time-line text-[#1a73b5] text-base" />
          </div>
          <p className="text-sm text-gray-600">週一至週五 &nbsp;09:00 – 18:00（週六、日及國定假日休息）</p>
        </div>
      </div>
    </div>
  );
}
